import { useState } from 'react'

interface ChatInputProps {
  onSendMessage: (message: string) => Promise<void>
  isLoading?: boolean
}

export function ChatInput({ onSendMessage, isLoading = false }: ChatInputProps) {
  const [message, setMessage] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()

    if (!message.trim() || isSubmitting || isLoading) {
      return
    }

    setIsSubmitting(true)
    try {
      await onSendMessage(message.trim())
      setMessage('')
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <form onSubmit={handleSubmit} className="border-t border-gray-200 dark:border-gray-700 p-4 bg-white dark:bg-gray-800">
      <div className="flex gap-2">
        <input
          type="text"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Напиши сообщение..."
          disabled={isSubmitting || isLoading}
          className="flex-1 px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-full text-sm text-gray-900 dark:text-white dark:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-accent disabled:opacity-50"
        />
        <button
          type="submit"
          disabled={!message.trim() || isSubmitting || isLoading}
          className="bg-accent text-white px-6 py-2 rounded-full text-sm font-semibold hover:opacity-90 transition-opacity disabled:opacity-50"
        >
          {isSubmitting ? '...' : '→'}
        </button>
      </div>
    </form>
  )
}
